/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A6Inputs */

const et_faq_a6 = /** @type {(inputs: Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tavaline veebileht näitab, kes sa oled. Konversioonile optimeeritud veebileht näitab kliendile, miks ta peaks just sinuga ühendust võtma. Vahe on sõnumis, struktuuris, kiiruses, usaldussignaalides ja müügipsühholoogias. Konversioonile optimeeritud veebilehel on selge väärtuspakkumine, tugevad CTA-d, nähtavad tõendid, lihtne päringuvorm, kiire laadimine ja loogiline teekond külastajast kliendiks. ScalingWebs ehitab veebilehti just selle eesmärgiga: rohkem päringuid, mitte lihtsalt ilusam disain.`)
};

const en_faq_a6 = /** @type {(inputs: Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A regular website shows who you are. A conversion-optimized website shows customers why they should contact you specifically. The difference is in messaging, structure, speed, trust signals, and sales psychology. A conversion-optimized website has a clear value proposition, strong CTAs, visible proof, a simple inquiry form, fast loading, and a logical path from visitor to customer. ScalingWebs builds websites for exactly this outcome: more inquiries, not just prettier design.`)
};

/**
* | output |
* | --- |
* | "A regular website shows who you are. A conversion-optimized website shows customers why they should contact you specifically. The difference is in messaging,..." |
*
* @param {Faq_A6Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_a6 = /** @type {((inputs?: Faq_A6Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A6Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_a6(inputs)
	return en_faq_a6(inputs)
});